import { useEffect, useMemo, useState } from 'react';

import { getWindowSafe } from '@change-corgi/core/window';

export type UseBreakpointStateReturn = ModelHookResult<{
	isMobile: boolean;
}>;

const MD_BREAKPOINT = 767;

export function useBreakpointState(): UseBreakpointStateReturn {
	const window = getWindowSafe();
	const [windowWidth, setWindowWidth] = useState(window?.innerWidth || 0);

	const isMobile = useMemo(() => windowWidth < MD_BREAKPOINT, [windowWidth]);

	useEffect(() => {
		function handleResize() {
			setWindowWidth(window?.innerWidth || 0);
		}

		let cleanUpFunction: () => void = () => {};

		if (window) {
			window.addEventListener('resize', handleResize);
			cleanUpFunction = () => window.removeEventListener('resize', handleResize);
		}

		return cleanUpFunction;
	}, [window]);

	return { data: { isMobile } };
}
